import { render } from "./BulkDownloadSelectedPartners.vue?vue&type=template&id=4b9a6cc0&scoped=true&ts=true"
import script from "./BulkDownloadSelectedPartners.vue?vue&type=script&lang=ts"
export * from "./BulkDownloadSelectedPartners.vue?vue&type=script&lang=ts"

import "./BulkDownloadSelectedPartners.vue?vue&type=style&index=0&id=4b9a6cc0&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9a6cc0"]])

export default __exports__